import { render, staticRenderFns } from "./MsgElementAudio.vue?vue&type=template&id=ff05f950"
import script from "./MsgElementAudio.vue?vue&type=script&lang=js"
export * from "./MsgElementAudio.vue?vue&type=script&lang=js"
import style0 from "./MsgElementAudio.vue?vue&type=style&index=0&id=ff05f950&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports